
import React, { useEffect, useState } from "react";
import { getFirestore, collection, getDocs } from "firebase/firestore";

const GroupCodeGeneratorNew = () => {
  const db = getFirestore();
  const [groups, setGroups] = useState([]);
  const [selectedGroupId, setSelectedGroupId] = useState("");
  const [groupDetails, setGroupDetails] = useState(null);
  const [individualScripts, setIndividualScripts] = useState([]);
  const [combinedScript, setCombinedScript] = useState("");
  const [copiedIndex, setCopiedIndex] = useState(null);
  const [copiedAll, setCopiedAll] = useState(false);

  useEffect(() => {
    const fetchGroups = async () => {
      const snapshot = await getDocs(collection(db, "sevakGroups"));
      const groupList = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setGroups(groupList);
    };
    fetchGroups();
  }, []);

  const fetchGroupDetails = () => {
    const selected = groups.find(group => group.id === selectedGroupId);
    if (selected) {
      setGroupDetails(selected);
      setIndividualScripts([]);
      setCombinedScript("");
    }
  };

  const generateScripts = () => {
    if (!groupDetails?.members?.length) return;

    // Individual scripts
    const scripts = groupDetails.members.map((m, idx) => {
      return {
        name: m.sevakName,
        script: `
(function(){
  function setReactValue(id,value){
    const el=document.getElementById(id);
    if(!el)return;
    const setter=Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype,"value").set;
    setter.call(el,value);
    el.dispatchEvent(new Event("input",{bubbles:true}));
  }
  function clickCameraIcon(){
    const icon=document.querySelector(".profile_cameraIcon__jP9cI");
    if(icon) icon.click();
  }
  function ensureFitnessChecked(){
    document.querySelectorAll('input[name="fitness"]').forEach(cb=>{if(!cb.checked) cb.click();});
  }
  ensureFitnessChecked();
  setReactValue("idNumber","${m.AdharNumber||m.idNumber}");
  setReactValue("sevakName","${m.sevakName}");
  setReactValue("surName","${m.surName}");
  setReactValue("fatherOrSpouseName","${m.fatherOrSpouseName}");
  setReactValue("dob","${m.dob}");
  setReactValue("mobileNo","${m.mobileNo}");
  setReactValue("email","${m.email}");
  setReactValue("gender","${m.gender}");
  setReactValue("profession","${m.profession}");
  setReactValue("country","${m.country}");
  setReactValue("state","${m.state}");
  setReactValue("district","${m.district}");
  setReactValue("city","${m.city}");
  setReactValue("street","${m.street}");
  setReactValue("doorNo","${m.doorNo}");
  setReactValue("pincode","${m.pincode}");
  setReactValue("nearestTtdTemple","${m.nearestTtdTemple}");
  clickCameraIcon();
})();
        `.trim()
      };
    });

    setIndividualScripts(scripts);

    // Combined script
    const combined = `
(function(){
  const SEVAKS=${JSON.stringify(groupDetails.members,null,2)};
  function setReactValue(id,value){
    const el=document.getElementById(id);
    if(!el)return;
    const setter=Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype,"value").set;
    setter.call(el,value);
    el.dispatchEvent(new Event("input",{bubbles:true}));
  }
  function clickCameraIcon(){
    const icon=document.querySelector(".profile_cameraIcon__jP9cI");
    if(icon) icon.click();
  }
  function ensureFitnessChecked(){
    document.querySelectorAll('input[name="fitness"]').forEach(cb=>{if(!cb.checked) cb.click();});
  }
  function fillFields(m){
    ensureFitnessChecked();
    setReactValue("idNumber",m.AdharNumber||m.idNumber);
    setReactValue("sevakName",m.sevakName);
    setReactValue("surName",m.surName);
    setReactValue("fatherOrSpouseName",m.fatherOrSpouseName);
    setReactValue("dob",m.dob);
    setReactValue("mobileNo",m.mobileNo);
    setReactValue("email",m.email);
    setReactValue("gender",m.gender);
    setReactValue("profession",m.profession);
    setReactValue("country",m.country);
    setReactValue("state",m.state);
    setReactValue("district",m.district);
    setReactValue("city",m.city);
    setReactValue("street",m.street);
    setReactValue("doorNo",m.doorNo);
    setReactValue("pincode",m.pincode);
    setReactValue("nearestTtdTemple",m.nearestTtdTemple);
  }
  const panel=document.createElement("div");
  panel.style.cssText="position:fixed;top:10px;right:10px;background:#fff;border:1px solid #ccc;padding:10px;z-index:99999;max-height:60vh;overflow:auto;";
  panel.innerHTML='<h4>Sevak Quick Fill</h4><p>Click name → fill fields & open photo dialog</p>';
  SEVAKS.forEach((m,i)=>{
    const btn=document.createElement("button");
    btn.textContent=\`\${i+1}. \${m.sevakName}\`;
    btn.style.cssText="display:block;width:100%;margin:4px 0;padding:6px;";
    btn.onclick=()=>{
      fillFields(m);
      clickCameraIcon();
      const save=document.querySelector(".profile_addBtn__oA2Q1");
      if(save){
        save.addEventListener("click",()=>{
          btn.style.background="#4CAF50";btn.style.color="#fff";
        },{once:true});
      }
    };
    panel.appendChild(btn);
  });
  document.body.appendChild(panel);
})();
    `.trim();

    setCombinedScript(combined);
  };

  const copyIndividual = (idx) => {
    navigator.clipboard.writeText(individualScripts[idx].script).then(() => {
      setCopiedIndex(idx);
      setTimeout(() => setCopiedIndex(null), 2000);
    });
  };

  const copyCombined = () => {
    navigator.clipboard.writeText(combinedScript).then(() => {
      setCopiedAll(true);
      setTimeout(() => setCopiedAll(false), 2000);
    });
  };

  return (
    <div className="container mt-4">
      <h3>Select Group</h3>
      <select
        className="form-select"
        value={selectedGroupId}
        onChange={(e) => setSelectedGroupId(e.target.value)}
      >
        <option value="">-- Select Group --</option>
        {groups.map((group) => (
          <option key={group.id} value={group.id}>
            {group.groupName}
          </option>
        ))}
      </select>
      <button className="btn btn-primary mt-2" onClick={fetchGroupDetails}>
        Fetch Details
      </button>

      {groupDetails && (
        <>
          <h5 className="mt-4">Members</h5>
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Name</th>
                <th>Street</th>
                <th>Mobile</th>
              </tr>
            </thead>
            <tbody>
              {groupDetails.members.map((m, idx) => (
                <tr key={idx}>
                  <td>{idx + 1}</td>
                  <td>{m.sevakName}</td>
                  <td>{m.street}</td>
                  <td>{m.mobileNo}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <button className="btn btn-success mt-3" onClick={generateScripts}>
            Convert to Code
          </button>
        </>
      )}

      {individualScripts.length > 0 && (
        <>
          <h5 className="mt-4">Individual Scripts</h5>
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Name</th>
                <th>Copy</th>
              </tr>
            </thead>
            <tbody>
              {individualScripts.map((row, idx) => (
                <tr key={idx}>
                  <td>{idx + 1}</td>
                  <td>{row.name}</td>
                  <td>
                    <button className="btn btn-sm btn-primary" onClick={() => copyIndividual(idx)}>
                      📋 Copy
                    </button>
                    {copiedIndex === idx && <span style={{ marginLeft: "10px", color: "green" }}>Copied!</span>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}

      {combinedScript && (
        <div className="mt-4">
          <h5>Combined Auto Script11</h5>
          <textarea className="form-control" rows={20} value={combinedScript} readOnly />
          <button className="btn btn-outline-primary mt-2" onClick={copyCombined}>
            📋 Copy Combined Script
          </button>
          {copiedAll && <span style={{ marginLeft: "10px", color: "green" }}>Copied!</span>}
        </div>
      )}
    </div>
  );
};

export default GroupCodeGeneratorNew;
